import React from 'react'
import classes from 'classnames'
import Loader from './Loader'

export default ({
    errors,
    name,
    type,
    value,
    label,
    errorText = false,
    startValue,
    isTextarea,
    placeholder,
    mask,
    minRows,
    length,
    minLength,
    maxLength,
    ...props
  }
  ) => {
    const Component = isTextarea ? 'textarea' : 'input'
    return (
        <div>
            <div className={['FundForm_field FundForm_field_background', errors && errors[name]? 'FundForm_field_error' : value? 'FundForm_field_completed' : null].join(' ')} style={{height: isTextarea ? props.height || "auto" : null, position: "relative"}}>
                <div className={['FundForm_field_label', errors && errors[name]? 'FundForm_field_label_error' : null].join(' ')}>{value || startValue? label : ' '}</div>
                <Component
                    type={type? type : 'text'}
                    name={name}
                    value={value? value : startValue? startValue : undefined}
                    placeholder={placeholder || label}
                    {...props}
                    className={!isTextarea? 'FundForm_inputField': null}
                    style={{marginTop: !value && !startValue? '13px' : '3px', border: isTextarea? '0px': undefined, width: isTextarea? 'calc(100% - 16px)' : undefined, resize: "none", height: isTextarea ? "80%" : undefined}}
                    //minRows={isTextarea && minRows? minRows : undefined}
                />
                {isTextarea && minLength && maxLength && (<div className='sas' style={{width: 'min-content', bottom: '15px', right: '30px', position: 'absolute', fontSize: "18px"}}>
                    {/* {length || 0}/{minLength} */}
                    {length || 0}/
                    {length && length > minLength? maxLength : minLength}
                    </div>)}
            </div>
            {/* <div className='FundForm FundForm_error'>{errors && errors[name] ? value? errorText : 'Обязательное поле' : ''}</div> */}
        </div>
    )
  }


// WEBPACK FOOTER //
// ./src/components/Input.jsx